import type { FaireProductEntity } from "../../entity_types/product";

export const p_6xmdsy6sv8: FaireProductEntity = {
  token: "p_6xmdsy6sv8",
  type: "product",
  name: "Dainty 18K Gold Filled  Zodiac Horoscope Sign Pendant CP1256",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/9bce924c32d654a67672cd9c097860231d8f41999750d97b54a4b265497cb8b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12d8947ecb9bce987d4447eb97d9383c29ea66d95be65e312996441d549ad4e0.jpeg",
  ],
  priceDollars: 6.24,
  description:
    "Creating your handcrafted jewelry pieces starts here! This is the best place to shop for fashionable and stylish jewelry findings with premium quality and competitive price!\nTake a look at more detail information about this item:\n\nDescription: \nMaterial: Brass Based with 18K Gold Filled, Cubic Zirconia.\nColor: Gold.\nSize: 17x15mm\nQTY: 1PC\n\n★Ship from CA, USA★\n\nAll sizes are approximate \nLead Free & Cadmium Free & Nickel Free\n\nIf you any questions regarding our products, bulk discount, and issue please send us a message.\nThank you for your visit!\n\nCARE INSTRUCTIONS\n\nTo care for your delicate jewelry and maintain its quality and longevity, please follow these guidelines:\n\n- Avoid contact with chemical solutions, perfumes, sweat, and saltwater/chlorine.\n- Use a soft, damp cloth to wipe off your jewelry regularly.\n- Keep your jewelry dry to prevent tarnishing.\n- Store different types of jewelry separately in a sealed bag to prevent oxidization.",
  tags: [],
  msrpDollars: 12.47,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:27.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
